var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"app"}},[_c('RwvHeader'),(!_vm.isAuthenticated)?_c('div',[_c('Login')],1):_vm._e(),(_vm.isAuthenticated)?_c('div',[_c('router-view')],1):_vm._e(),_c('RwvFooter')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }